var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
      attrs: {
        title: "写站内信",
        width: "1200px",
        center: "",
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "inputForm",
          attrs: {
            size: "small",
            model: _vm.inputForm,
            "label-width": "120px",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "发送到",
                        prop: "receiverIds",
                        rules: [
                          {
                            required: true,
                            message: "收信人不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("user-select", {
                        attrs: { value: _vm.inputForm.receiverIds },
                        on: {
                          getValue: function (value) {
                            _vm.inputForm.receiverIds = value
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "标题",
                        prop: "mailDTO.title",
                        rules: [],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入标题" },
                        model: {
                          value: _vm.inputForm.mailDTO.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm.mailDTO, "title", $$v)
                          },
                          expression: "inputForm.mailDTO.title",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "内容" } },
                    [
                      _c("WangeEditor", {
                        ref: "editor",
                        model: {
                          value: _vm.inputForm.mailDTO.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm.mailDTO, "content", $$v)
                          },
                          expression: "inputForm.mailDTO.content",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", icon: "el-icon-circle-close" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("关闭")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "danger" },
              on: {
                click: function ($event) {
                  return _vm.doSubmit("0")
                },
              },
            },
            [_vm._v("存为草稿")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.doSubmit("1")
                },
              },
            },
            [_vm._v("发送邮件")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }